var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancelCircleModal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6253 14.626L8.37598 8.37598M8.37664 14.626L14.626 8.37598",
    stroke: "#2177FE",
    strokeWidth: 1.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9173 11.5003C21.9173 5.74736 17.2536 1.08366 11.5007 1.08366C5.74768 1.08366 1.08398 5.74736 1.08398 11.5003C1.08398 17.2533 5.74768 21.917 11.5007 21.917C17.2536 21.917 21.9173 17.2533 21.9173 11.5003Z",
    stroke: "#2177FE",
    strokeWidth: 1.5625
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelCircleModal);
export default __webpack_public_path__ + "static/media/CancelCircleModal.6f7bf4603965e4742b27597c7a8615b6.svg";
export { ForwardRef as ReactComponent };